import { TableColumn } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import {
  commodityTableIcon,
  deviceTypeTableIcon
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { BubbleColumnComponent } from 'src/app/shared/components/listing-table/components/bubble-column.component';
import { IconColumnComponent } from 'src/app/shared/components/listing-table/components/icon-column.component';
import { LocationColumnComponent } from 'src/app/shared/components/table-columns/location-column.component';
import { CommDeviceIdColumnComponent } from 'src/app/pages/equipment/devices/components/column/comm-device-id-column.component';
import { SerialNumberColumnComponent } from 'src/app/pages/equipment/devices/components/column/serial-number-column.component';

export const createAlarmsColumns = (opts: { isSingleCommodityClient: boolean }): TableColumn[] => [
  {
    field: 'dateTime',
    title: TranslateRegistry.get.ALARMS.VIEW_TABLE.DATE_TIME,
    width: 200,
    sortable: true
  },
  {
    field: 'severity',
    title: TranslateRegistry.get.ALARMS.VIEW_TABLE.SEVERITY,
    width: 200,
    sortable: false,
    cmp: BubbleColumnComponent
  },
  {
    field: 'groupName',
    title: TranslateRegistry.get.ALARMS.VIEW_TABLE.ALARM_GROUP,
    width: 200,
    sortable: false
  },
  { field: 'name', title: TranslateRegistry.get.ALARMS.VIEW_TABLE.ALARM_NAME, width: 300, sortable: false },
  {
    field: 'deviceTypeName',
    title: TranslateRegistry.get.ALARMS.VIEW_TABLE.DEVICE_TYPE,
    width: 200,
    sortable: false,
    icon: deviceTypeTableIcon
  },
  {
    field: 'commodity',
    title: TranslateRegistry.get.ALARMS.VIEW_TABLE.COMMODITY,
    width: 200,
    sortable: false,
    icon: commodityTableIcon,
    cmp: IconColumnComponent,
    isHidden: opts.isSingleCommodityClient
  },
  {
    field: 'commDeviceId',
    title: TranslateRegistry.get.ALARMS.VIEW_TABLE.COMM_DEVICE_ID,
    sortable: true,
    width: 200,
    cmp: CommDeviceIdColumnComponent
  },
  {
    field: 'serialNumber',
    title: TranslateRegistry.get.ALARMS.VIEW_TABLE.SERIAL_NUMBER,
    sortable: true,
    width: 200,
    cmp: SerialNumberColumnComponent
  },
  { field: 'modelName', title: TranslateRegistry.get.ALARMS.VIEW_TABLE.MODEL_NAME, width: 200, sortable: false },
  {
    field: 'location',
    title: TranslateRegistry.get.ALARMS.VIEW_TABLE.LOCATION,
    width: 200,
    sortable: false,
    cmp: LocationColumnComponent
  }
];
